import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';
import { Vehicle } from '@/vehicles/vehicle.model';
import { Driver } from '@/drivers/driver.model';

@Component({
	selector: 'app-settlement-bonus-list-filter',
	templateUrl: './settlement-bonus-list-filter.component.html',
	styleUrls: ['./settlement-bonus-list-filter.component.css'],
})
export class SettlementBonusListFilterComponent extends FiltersComponent {
	@Input() drivers: Array<Driver>;
	@Input() settlementBonusNames: Array<any>;
	@Input() settlementKinds: Array<any>;
	@Input() users: Array<any>;
	@Input() driverKinds: Array<any>;
	@Input() confirm: Array<any>;
	@Input() workshop: Array<any>;
	@Input() vehicles: Array<Vehicle>;

	filters = {
		drivers: [],
		settlementBonusName: [],
		settlementKind: [],
		confirm: [],
		workshop: [],
		createBy: [],
		driverKinds: [],
		vehicles: [],
		confirmPerson: [],
		date_from: null,
		date_to: null,
	};
}
